export default "__VITE_ASSET__CcK_z6Nt__"